import {
  GET_RELATED_CIF,
  CLEAR_RELATED_CIF,
  GET_RELATED_COMPANIES,
  CLEAR_RELATED_COMPANIES,
  GET_RELATED_CIF_ALLOWED,
} from "../constants/constants";

const initialSessionState = { relatedCifCross: [], relatedCompanies: [], allowedCompanies: null };

export default (state = initialSessionState, action) => {
  switch (action.type) {
    case GET_RELATED_CIF:
      return {
        ...state,
        relatedCifCross: [...action.related],
      };
    case GET_RELATED_COMPANIES:
      return {
        ...state,
        relatedCompanies: action.related.childs !== null ? [...action.related.childs] : []
      };
    case GET_RELATED_CIF_ALLOWED:
      return {
        ...state,
        allowedCompanies: action.companies
      };
    case CLEAR_RELATED_CIF:
      return {
        ...state,
        relatedCifCross: [],
      };
    case CLEAR_RELATED_COMPANIES:
      return {
        ...state,
        relatedCompanies: []
      };
    default:
      return state;
  }
};

export const getRelatedCif = (state) => state.cifCrossReducer.relatedCifCross;
export const relatedCompanies = (state) => state.cifCrossReducer.relatedCompanies;
export const getAllowedCompanies = (state) => state.cifCrossReducer.allowedCompanies;
